module.exports = __webpack_public_path__ + "img/27.66c461ea.png";